import styled from "styled-components";
import { Container, Form, Row } from "react-bootstrap";

export const TeacherIDForm = styled(Form)`
  width: 60%;
  @media screen and (max-width: 425px) {
    width: 80%;
  }
  input,
  input:focus,
  input:active {
    height: 100%;
    border-radius: 0px;
    color: var(--text-color-muted);
    font-size: var(--font-size-sm);
    font-weight: 500;
    &:-webkit-autofill {
      box-shadow: 0 0 0px 1000px white inset !important;
    }
  }
  .teacher-id-input {
    height: 50px;
    max-width: 245px;
    border-radius: 6px;
    border: 1px solid var(--text-color-muted);
    @media screen and (max-width: 576px) {
      font-size: var(--font-size-sm);
    }
  }
  .label-teacher-id {
    margin-top: 10px;
    font-size: var(--font-size-sm);
    color: var(--blue-color-dark);
    @media screen and (max-width: 576px) {
      font-size: var(--font-size-xs);
    }
    span {
      margin-bottom: 10px;
      text-align: center;
    }
  }
  .invalid-text {
    color: var(--danger-color);
  }
  .invalid-input {
    border: 1px solid var(--danger-color);
  }
  .form-text {
    font-weight: 300;
    font-size: var(--font-size-xs);
    margin: 0px 20px;
    @media screen and (max-width: 425px) {
      width: 80%;
    }
  }
  button {
    width: 125px;
    height: 38px;
    font-size: var(--font-size-base);
    box-shadow: var(--box-shadow1);
    &:disabled {
      box-shadow: none;
    }
  }
`;
export const MessageForm = styled(Form)`
  width: 100%;
  .send-message {
    font-size: var(--font-size-sm);
    color: var(--text-color-dark);
  }
  .teacher-name {
    font-size: var(--font-size-sm);
    color: var(--tertiary-color);
  }
  button {
    width: 150px;
    height: 38px;
    font-size: var(--font-size-base);
    box-shadow: var(--box-shadow1);
  }
  .textarea-message {
    width: 417px;
    height: 112px;
    border: 1px solid #a4adbc;
    @media screen and (max-width: 576px) {
      width: 280px;
    }
    textarea {
      resize: none;
      border: none;
      background: var(--bg-color);
      width: 100%;
      min-height: 112px;
    }
  }
  .form-text {
    font-weight: 300;
    font-size: var(--font-size-xs);
    color: var(--text-color-dark);
  }
`;
